module.exports = __webpack_public_path__ + "assets/img/3.136d3be4.png";